export {
  AiModel,
  AiModelWithoutAuto,
  AiProvider,
  AiThinkingLevel,
  AiVoice,
  ChartAggregation,
  ChatMessageKind,
  DartboardKind,
  EmojiSkinTone,
  EntityName,
  EventActor,
  EventKind,
  ExecutionMode,
  FilterApplicability,
  FilterConnector,
  FolderKind,
  GithubIntegrationTenantExtensionStatus as GithubIntegrationStatus,
  IconKind,
  Language,
  LayoutKind,
  NotionIntegrationTenantExtensionStatus as NotionIntegrationStatus,
  OperationKind,
  OperationModelKind,
  PieChartDisplayMetric,
  Priority,
  PropertyKind,
  ReassignBehavior,
  RelationshipKindKind,
  ReleaseChannel,
  SamlConfigTenantExtensionStatus as SamlConfigStatus,
  SkillKind,
  SlackIntegrationTenantExtensionStatus as SlackIntegrationStatus,
  SpaceKind,
  SprintMode,
  ChartType as StatisticType,
  StatusKind,
  Subscription,
  SubtaskDisplayMode,
  SummaryStatisticKind,
  TaskDetailMode,
  TaskKindKind,
  TaskLinkKind,
  TaskSourceKind,
  TextSentinel,
  Theme,
  TransactionKind,
  TriggerKind,
  TutorialName,
  UserRole,
  UserStatus,
  ViewKind,
  ViewMode,
  WebhookEventKind,
} from "~/api/generated";
export { Key } from "~/shared/keyboardKeys";

export enum PageLinkMode {
  DEFAULT = "default",
  NOTIFICATION = "notification",
  CHAT_ENABLED = "chatEnabled",
  CHAT_DISABLED = "chatDisabled",
}

export enum PageKind {
  AGENTS = "agents",
  DARTBOARD = "dartboard",
  DASHBOARD = "dashboard",
  DOC = "doc",
  DASHBOARDS_ROOT = "dashboards",
  FOLDER = "folder",
  FORM = "form",
  HOME = "home",
  INBOX = "inbox",
  NOT_FOUND = "notFound",
  SPACE = "space",
  SKILL = "skill",
  VIEW = "view",
  VIEWS_ROOT = "views",
}

export enum DocKind {
  DOC = "Doc",
}

export enum DashboardKind {
  DASHBOARD = "Dashboard",
}

export enum FormKind {
  FORM = "Form",
}

export enum PagePseudoKind {
  NOT_FOUND = "Not found",
  AGENTS = "Agents",
  HOME = "Home",
  INBOX = "Inbox",
  DASHBOARD = "Dashboard",
  DASHBOARDS = "Dashboards",
  VIEWS = "Views",
}

export enum SizeFormat {
  TSHIRT = "T-shirt",
  FIBONACCI = "Fibonacci",
  EXPONENTIAL = "Exponential",
  LINEAR = "Linear",
  FREE_ENTRY = "Free entry",
}

export enum TshirtSize {
  EXTRA_SMALL = "XS",
  SMALL = "S",
  MEDIUM = "M",
  LARGE = "L",
  EXTRA_LARGE = "XL",
}

export enum DropdownMenuItemKind {
  INTERNAL_LINK,
  EXTERNAL_LINK,
  BUTTON,
  COMPONENT,
}

export enum AgentKind {
  AGENT = "agent",
  CONFIG = "config",
  CREATE = "create",
}

export enum AgentCategory {
  ASSISTANT = "Assistant",
  CODING = "Coding",
  SALES = "Sales",
  DESIGN = "Design",
  MARKETING = "Marketing",
}

export enum FilterType {
  AI = "AI",
  DATE = "DATE",
  INPUT = "INPUT",
  NUMBER = "NUMBER",
  VALUE = "VALUE",
}

export enum SpeechToTextShortcutPriority {
  CRITICAL = 0,
  HIGH = 1,
  NORMAL = 2,
  LOW = 3,
}

export enum CommandId {
  ADD_ATTACHMENT,
  ADD_FILTER,
  ADD_LINK,
  API_DOCS,
  CAREERS_AT_DART,
  CHANGE_ASSIGNEE_TO_SELF,
  CHANGE_ASSIGNEE_TO_UNASSIGNED,
  CHANGE_ASSIGNEE,
  CHANGE_REVIEWER_TO_SELF,
  CHANGE_REVIEWER,
  CHANGE_DUE_DATE,
  CHANGE_FILTER_APPLICABILITY,
  CHANGE_FILTER_CONNECTOR,
  CHANGE_FILTER_VALUES,
  CHANGE_PARENT,
  CHANGE_PRIORITY_TO_CRITICAL,
  CHANGE_PRIORITY_TO_HIGH,
  CHANGE_PRIORITY_TO_LOW,
  CHANGE_PRIORITY_TO_MEDIUM,
  CHANGE_PRIORITY_TO_UNPRIORITIZED,
  CHANGE_PRIORITY,
  CHANGE_SIZE,
  CHANGE_START_DATE,
  CHANGE_STATUS_TO_DEFAULT_FINISHED,
  CHANGE_STATUS,
  CHANGELOG,
  CHAT_ON_DISCORD,
  CHAT_WITH_AI,
  CLEAR_FILTER,
  CONFIGURE_ZOHO_FLOW_INTEGRATION,
  COPY_BRANCH,
  COPY_LINK,
  COPY_TASK_AS_PROMPT,
  CREATE_DARTBOARD,
  CREATE_DASHBOARD,
  CREATE_DOC,
  CREATE_FOLDER,
  CREATE_SPACE,
  CREATE_SUBTASKS,
  CREATE_TASK_QUICKLY,
  CREATE_TASK_UNDERNEATH,
  CREATE_TASK,
  CREATE_VIEW,
  CYCLE_BLOCKED_STATUSES,
  CYCLE_CANCELED_STATUSES,
  CYCLE_FINISHED_STATUSES,
  CYCLE_STARTED_STATUSES,
  CYCLE_UNSTARTED_STATUSES,
  DELETE_TASK,
  DESELECT_TASK,
  EDIT_ASSIGNEES,
  EDIT_REVIEWERS,
  EDIT_DESCRIPTION,
  EDIT_TAGS,
  EDIT_TITLE,
  EDITOR_ADD_LINK,
  EDITOR_AI_ACTIONS,
  EDITOR_BOLD,
  EDITOR_CANCEL_DICTATION,
  EDITOR_CONFIRM_DICTATION,
  EDITOR_IMPROVE_CONTENT,
  EDITOR_ITALICIZE,
  EDITOR_MOVE_BLOCK_DOWN,
  EDITOR_MOVE_BLOCK_UP,
  EDITOR_SET_BULLETED_LIST,
  EDITOR_SET_CHECKLIST,
  EDITOR_SET_CODE_BLOCK,
  EDITOR_SET_CODE_SNIPPET,
  EDITOR_SET_HORIZONTAL_RULE,
  EDITOR_SET_LARGE_HEADER,
  EDITOR_SET_MEDIUM_HEADER,
  EDITOR_SET_NUMBERED_LIST,
  EDITOR_SET_QUOTE,
  EDITOR_SET_SMALL_HEADER,
  EDITOR_SET_STANDARD_TEXT,
  EDITOR_SET_TABLE,
  EDITOR_SET_TOGGLE_BLOCK,
  EDITOR_START_DICTATION,
  EDITOR_STRIKETHROUGH,
  EDITOR_TEXT_OR_BG_COLOR,
  EDITOR_TOGGLE_CHECKED,
  EDITOR_UNDERLINE,
  EDITOR_USE_AI,
  EMAIL_SUPPORT,
  EXPORT_DATA,
  FIND_IN_PAGE,
  FIND_US_ON_BLUESKY,
  FIND_US_ON_INSTAGRAM,
  FIND_US_ON_LINKEDIN,
  FIND_US_ON_THREADS,
  FIND_US_ON_TIKTOK,
  FIND_US_ON_X,
  FIND_US_ON_YOUTUBE,
  GET_THE_MOBILE_APP,
  GO_DOWN,
  GO_TO_AGENTS,
  GO_TO_BOTTOM_OF_DARTBOARD,
  GO_TO_CHAT,
  GO_TO_DARTBOARD,
  GO_TO_DASHBOARD,
  GO_TO_DASHBOARDS,
  GO_TO_DOC,
  GO_TO_FOLDER,
  GO_TO_HOME,
  GO_TO_INBOX,
  GO_TO_MEDIA_NEXT,
  GO_TO_MEDIA_PREVIOUS,
  GO_TO_MY_TASKS,
  GO_TO_SETTINGS,
  GO_TO_TASK,
  GO_TO_TOP_OF_DARTBOARD,
  GO_TO_TRASH,
  GO_TO_VIEW,
  GO_TO_VIEWS,
  GO_UP,
  HELP_CENTER,
  HIDE_SUBTASKS,
  IMPORT_DATA,
  INDENT_TO_SUBTASK,
  INVITE_TEAMMATES,
  LOG_OUT,
  MANAGE_ACCOUNT,
  MANAGE_API,
  MANAGE_AUTOMATIONS,
  MANAGE_CHATGPT_INTEGRATION,
  MANAGE_CLAUDE_INTEGRATION,
  MANAGE_DISCORD_INTEGRATION,
  MANAGE_EMAIL_INTEGRATION,
  MANAGE_FORMS,
  MANAGE_GITHUB_INTEGRATION,
  MANAGE_IDENTITY_AND_PROVISIONING,
  MANAGE_NOTIFICATIONS,
  MANAGE_NOTION_INTEGRATION,
  MANAGE_PIPEDREAM_INTEGRATION,
  MANAGE_PLANS_AND_BILLING,
  MANAGE_PROPERTIES,
  MANAGE_SLACK_INTEGRATION,
  MANAGE_WEBHOOKS,
  MANAGE_WORKSPACE_PREFERENCES,
  MANAGE_ZAPIER_INTEGRATION,
  MARKDOWN_ADD_IMAGE,
  MARKDOWN_ADD_LINK,
  MARKDOWN_BOLD,
  MARKDOWN_HIGHLIGHT,
  MARKDOWN_ITALICIZE,
  MARKDOWN_SET_BULLETED_LIST,
  MARKDOWN_SET_CHECKLIST,
  MARKDOWN_SET_CODE_BLOCK,
  MARKDOWN_SET_CODE_SNIPPET,
  MARKDOWN_SET_HORIZONTAL_RULE,
  MARKDOWN_SET_LARGE_HEADER,
  MARKDOWN_SET_MEDIUM_HEADER,
  MARKDOWN_SET_NUMBERED_LIST,
  MARKDOWN_SET_QUOTE,
  MARKDOWN_SET_SMALL_HEADER,
  MARKDOWN_SET_TABLE,
  MARKDOWN_SET_TOGGLE_BLOCK,
  MARKDOWN_STRIKETHROUGH,
  MARKDOWN_UNDERLINE,
  MOVE_TASK_DOWN,
  MOVE_TASK_UP,
  MOVE_TO_DARTBOARD,
  NAV_BACK,
  NAV_FORWARD,
  NAV_REFRESH,
  OPEN_HELP_DOCS,
  OPEN_IN_BROWSER,
  OPEN_IN_DESKTOP_APP,
  OPEN_SETTINGS,
  OPEN_TASK,
  OPEN_VUE_INSPECTOR,
  OUR_WEBSITE,
  OUTDENT_TO_UNSUBTASK,
  PRIVACY_POLICY,
  QC_IGNORE_SUGGESTION,
  QC_PREFIX_ASSIGNEE,
  QC_PREFIX_ASSIGNEES,
  QC_PREFIX_DARTBOARD,
  QC_PREFIX_DUE_DATE,
  QC_PREFIX_GENERAL,
  QC_PREFIX_PRIORITY,
  QC_PREFIX_SIZE,
  QC_PREFIX_STATUS,
  QC_PREFIX_TAG,
  QC_UNPREFIX_ASSIGNEE,
  QC_UNPREFIX_DARTBOARD,
  QC_UNPREFIX_DUE_DATE,
  QC_UNPREFIX_PRIORITY,
  QC_UNPREFIX_SIZE,
  QC_UNPREFIX_STATUS,
  QC_UNPREFIX_TAG,
  RECOMMEND_PROPERTIES,
  RECOMMEND_SUBTASKS,
  REDO,
  REMOVE_FILTER,
  REPLICATE_TASK,
  RESET_VIEW_CLOSE,
  RESET_VIEW,
  RESUME_DRAFT,
  SAVE_CHAT,
  SAVE_COMMENT,
  SAVE_TASK_OPEN_IN_CREATION_MODAL_AND_CREATE_ANOTHER,
  SAVE_TASK_OPEN_IN_CREATION_MODAL,
  SAVE_TASK,
  SCHEDULE_A_CALL,
  SELECT_ALL_ABOVE,
  SELECT_ALL_BELOW,
  SELECT_ALL,
  SELECT_NEXT_ABOVE,
  SELECT_NEXT_BELOW,
  SELECT_TASK,
  SET_LAYOUT_TO_BOARD,
  SET_LAYOUT_TO_CALENDAR,
  SET_LAYOUT_TO_WORKFLOW,
  SET_LAYOUT_TO_LIST,
  SET_LAYOUT_TO_NEXT,
  SET_LAYOUT_TO_PREVIOUS,
  SET_LAYOUT_TO_ROADMAP,
  SET_REMINDER,
  SHARE_FEEDBACK,
  SHOW_STANDUP_TIMER,
  SHOW_SUBTASKS,
  START_NEXT_SPRINT,
  START_TIMER,
  STATUS,
  STOP_CHAT,
  SWAP_ASSIGNEE,
  SWAP,
  SWITCH_TO_DARK_MODE,
  SWITCH_TO_LIGHT_MODE,
  SWITCH_VIEW_MODE_TO_TAB_1,
  SWITCH_VIEW_MODE_TO_TAB_2,
  SWITCH_VIEW_MODE_TO_TAB_3,
  SWITCH_VIEW_MODE_TO_TAB_4,
  SWITCH_VIEW_MODE_TO_TAB_5,
  SWITCH_VIEW_MODE_TO_TAB_6,
  SWITCH_VIEW_MODE_TO_TAB_7,
  SWITCH_VIEW_MODE_TO_TAB_8,
  SWITCH_VIEW_MODE_TO_TAB_9,
  SWITCH_VIEW_MODE_TO_TAB_10,
  TERMS_OF_USE,
  TOGGLE_AI_CHAT_PANEL_TO_CLOSED,
  TOGGLE_AI_CHAT_PANEL_TO_OPEN,
  TOGGLE_COMMAND_CENTER,
  TOGGLE_FILTERS_AND_SORTS_TO_HIDDEN,
  TOGGLE_FILTERS_AND_SORTS_TO_SHOWN,
  TOGGLE_LEFTBAR_TO_COLLAPSED,
  TOGGLE_LEFTBAR_TO_EXPANDED,
  TOGGLE_KEYBOARD_SHORTCUTS,
  TOGGLE_SEARCH,
  TOGGLE_TASK_OPEN_IN_DETAIL,
  TOGGLE_THEME,
  UNDO,
  UNKNOWN,
  USE_DART_IN_CHATGPT,
  USE_THE_POMODORO_TIMER,
  USE_THE_PYTHON_LIBRARY,
  USE_THE_TYPESCRIPT_AND_JAVASCRIPT_LIBRARY,
  VIEW_ATTACHMENTS,
  VIEW_COMMENTS,
  VIEW_LINKS,
  ZOOM_IN,
  ZOOM_OUT,
}

export enum CommandActionType {
  CALLBACK,
  EXTERNAL_LINK,
  SELECT,
  MULTISELECT,
}

export enum KeyboardShortcutStrokeKind {
  KEY,
  MARKDOWN,
  SEPARATOR,
  TEXT,
}

export enum Placement {
  AUTO = "auto",
  BOTTOM = "bottom",
  BOTTOM_LEFT = "bottom-start",
  BOTTOM_RIGHT = "bottom-end",
  LEFT = "left",
  LEFT_TOP = "left-start",
  LEFT_BOTTOM = "left-end",
  RIGHT = "right",
  RIGHT_TOP = "right-start",
  RIGHT_BOTTOM = "right-end",
  TOP = "top",
  TOP_LEFT = "top-start",
  TOP_RIGHT = "top-end",
}

export enum ModalPosition {
  BOTTOM,
  LEFT,
  RIGHT,
  TOP,
  CENTER,
}

export enum ModelType {
  TASK = "task",
}

export enum AnimationDuration {
  SHORT = 100,
  MEDIUM = 200,
  LONG = 300,
}

export enum ModalKind {
  AGENT_CREATION,
  APP_DOWNLOAD,
  COMMAND_CENTER,
  CREATE_TASK,
  FEEDBACK,
  FULLSCREEN_MEDIA,
  INTERNAL_FORM,
  START_BUILD_MODE,
  LINK,
  MOBILE_LEFTBAR,
  ONBOARDING,
  ONBOARDING_VIDEO,
  PERMISSIONS,
  REMAP_MODAL,
  SEARCH,
  SETTINGS,
  SHORTCUTS,
  SWITCH_TO_DESKTOP,
  UPGRADE_REQUIRED,
}

export enum EditorMode {
  BOARD,
  CALENDAR,
  CHIP_RECOMMENDATION,
  CHIP,
  CONTEXT_MENU,
  DOC,
  FILTER,
  FOLDER,
  FORM,
  AUTOMATION,
  LIST_MINI_ROADMAP,
  LIST_MINI_TCM,
  LIST_MINI,
  LIST,
  NLP,
  DETAIL_RECOMMENDATION,
  DETAIL,
  ROADMAP,
  TCM,
}

export enum RecommendationKind {
  ACTION_ITEMS = "action-items",
  BRAINSTORM = "brainstorm",
  CONVERT_TO_TASKS = "convert-to-tasks",
  CUSTOM = "custom",
  IMPROVE = "improve",
  PROPERTIES = "properties",
  SIMPLIFY = "simplify",
  SPLIT = "split",
  SUBTASKS = "subtasks",
  TRANSLATE = "translate",
  WRITE = "write",
}

export enum RecommendationAction {
  DISCARD,
  KEEP,
  REPLACE,
}

export enum ButtonStyle {
  PRIMARY,
  SECONDARY,
  DANGER,
  SECONDARY_DANGER,
  RECOMMENDATION,
  SECONDARY_RECOMMENDATION,
  CHIP,
}

export enum ButtonSize {
  CHIP,
  SMALL,
  LARGE,
}

export enum SectionKind {
  COMPONENT,
  CREATE,
  DEFAULT,
  DISABLED,
  DROPDOWN_CREATE,
  DROPDOWN,
}

// TODO remove because this hardcodes relationship types
export enum RelationshipDropdownKind {
  BLOCKED,
  BLOCKING,
  CREATE_SUBTASK,
  DUPLICATE,
  MERGED_INTO,
  RELATES_TO,
  SET_PARENT,
  SET_SUBTASK,
}

export enum DialogMode {
  STANDARD,
  SECONDARY_ACTION,
  DELETE,
}

export enum IconSize {
  XS,
  S,
  M,
  L,
  XL,
}

export enum IconMode {
  PRIMARY,
  DELETE,
  NONE,
}

export enum Entitlement {
  TRIAL_DAYS = "trialDays",
  TRIAL_START = "trialStart",
  TRIAL_TYPE = "trialType",
  MAX_USERS = "maxUsers",
  ROLES = "roles",
  STATUSES = "statuses",
  MAX_CUSTOM_PROPERTIES = "maxCustomProperties",
  MAX_DASHBOARDS = "maxDashboards",
  MAX_FORMS = "maxForms",
  MAX_PUBLIC_VIEWS = "maxPublicViews",
  MAX_TASK_KINDS = "maxTaskKinds",
  DISCORD = "discord",
  GITHUB = "github",
  SLACK = "slack",
  WEBHOOKS = "webhooks",
  ZAPIER = "zapier",
}

export enum GoogleLoginAction {
  LOGIN = "login",
  SIGN_UP = "signup",
}

export enum GoogleLoginPlatform {
  WEB = "web",
  DESKTOP = "desktop",
  MOBILE = "mobile",
}

export enum BillingPeriod {
  MONTHLY = "month",
  ANNUALLY = "year",
}

export enum ActivityKind {
  CREATED = "Created",
  UPDATED = "Updated",
}

export enum TypeaheadSpecialEntity {
  DARTBOARD = "dartboard",
  DOC = "doc",
  FOLDER = "folder",
  SKILL = "skill",
  TASK = "task",
  USER = "user",
  VIEW = "view",
}

export enum FeedbackRating {
  GOOD = "Good",
  BAD = "Bad",
}

export enum RecurrenceKind {
  DAILY = "Daily",
  WEEKLY = "Weekly",
  MONTHLY = "Monthly",
  YEARLY = "Yearly",
}

export enum StoreDataPreservationMode {
  NONE,
  RECENT,
  ALL,
}

export enum InboxFilter {
  UNREAD = "unread",
  NONE = "all",
}

export enum NotificationType {
  INFO,
  SUCCESS,
  WARNING,
  ERROR,
}

export enum NumberFormat {
  INTEGER = "Integer",
  PERCENTAGE = "Percentage",
  DOLLARS = "Dollars",
}

export enum Feature {
  SIGNUP_QUESTIONS = 0,
  REVERSE_TRIAL = 1,
}

export enum ModalWidth {
  XS,
  S,
  M,
  L,
  XL,
  XXL,
  XXXL,
  FULL,
  CUSTOM,
}

export enum ColorHex {
  SOFT_BLUE = "#6366f1",
  SOFT_VIOLET = "#8b5cf6",
  BRIGHT_MAGENTA = "#d946ef",
  SOFT_PINK = "#ec4899",
  BRIGHT_RED = "#f43f5e",
  VIVID_RED = "#f02424",
  BRIGHT_BLUE = "#3b82f6",
  VIVID_BLUE = "#0ea5e9",
  STRONG_CYAN = "#2dd4bf",
  SOFT_CYAN = "#4ade80",
  VIVID_ORANGE = "#fa9e15",
  AMBER = "#f97316",
  MODERATE_ORANGE = "#b97d37",
  CAMEL = "#cb985c",
  LIME_GREEN = "#10b981",
  STRONG_GREEN = "#84cc16",
  VIVID_YELLOW = "#f0e800",
  PURE_YELLOW = "#ffcc00",
}

export enum PomodoroBackgroundKind {
  COLOR = "color",
  GRADIENT = "gradient",
  IMAGE = "image",
}

export enum VisualizationItemType {
  ADD_GROUP = "add-group",
  COLLAPSED_GROUPS = "collapsed-groups",
  CREATE_MODAL = "create-modal",
  GROUP_HEADER = "group-header",
  GROUP_NEW_TASK = "group-new-task",
  LOADING = "loading",
  MARGIN = "margin",
  NEW_TASK = "new-task",
  TASK = "task",
}

export enum FolderSort {
  RECENT_ASC = "updated_at",
  RECENT_DESC = "-updated_at",
  CREATED_ASC = "created_at",
  CREATED_DESC = "-created_at",
  TITLE_ASC = "title",
  TITLE_DESC = "-title",
  ORDER = "order",
}

export enum WebhookCellType {
  ACTIONS = "actions",
  EVENTS = "events",
  STATUS = "status",
  URL = "url",
}

export enum PresignedUrlKind {
  ATTACHMENT = "attachment",
  IMPORT_RECORD = "importRecord",
  PROFILE = "profile",
  WORKSPACE = "workspace",
}
